"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDocumentWebViewer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var webviewer_1 = __importDefault(require("@pdftron/webviewer"));
// import { Box } from '@material-ui/core';
// import { LoadingIndicator } from '../../atoms';
var styles_1 = __importDefault(require("./styles"));
var defaultWebViewerOptions = Object.freeze({
    // NOTE: product key should be provided in each app
    path: '/webviewer',
    enableAnnotations: false,
    enableFilePicker: false,
    enableMeasurement: false,
    enableRedaction: false,
    disabledElements: [
        'ribbons',
        'header',
        'menuButton',
        'leftPanelButton',
        'viewControlsButton',
        'searchButton'
    ]
});
/**
 * WebViewer component which acts as the "target" that the WebViewer instance will initialize on
 * @note currently set to "autofill" to parent element
 * @todo may need to make these styles more addressable
 */
var WebViewerComponent = react_1.default.forwardRef(function (props, ref) {
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "webviewer-wrapper", className: classes.root }, { children: (0, jsx_runtime_1.jsx)("div", { "data-testid": "webviewer", ref: ref, className: classes.inner }) })));
});
/**
 * Components and support for PDFtron web viewer
 */
var useDocumentWebViewer = function (_a) {
    var _b = _a === void 0 ? {} : _a, options = _b.options, _c = _b.onWebViewerReady, onWebViewerReady = _c === void 0 ? function () { } : _c;
    var container = react_1.default.useRef(null);
    var instance = react_1.default.useRef(null);
    /**
     * Initialize web viewer
     */
    var initializeWebViewer = react_1.default.useCallback(function (element) {
        return (0, webviewer_1.default)(__assign(__assign({}, defaultWebViewerOptions), options), element);
    }, [options]);
    var loadWebViewer = react_1.default.useCallback(function (element) { return __awaiter(void 0, void 0, void 0, function () {
        var viewerInstance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, initializeWebViewer(element)];
                case 1:
                    viewerInstance = _a.sent();
                    instance.current = viewerInstance;
                    return [2 /*return*/, viewerInstance];
            }
        });
    }); }, [initializeWebViewer]);
    /**
     * Load web viewer
     */
    react_1.default.useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var wvInstance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!instance.current && container.current)) return [3 /*break*/, 2];
                        console.log('loading web viewer');
                        return [4 /*yield*/, loadWebViewer(container.current)];
                    case 1:
                        wvInstance = _a.sent();
                        onWebViewerReady(wvInstance);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })();
    }, [loadWebViewer, onWebViewerReady]);
    var WebViewer = react_1.default.memo(function () { return (0, jsx_runtime_1.jsx)(WebViewerComponent, { ref: container }); });
    return {
        WebViewer: WebViewer,
        instance: instance
    };
};
exports.useDocumentWebViewer = useDocumentWebViewer;
